<script setup>
import { ref, onMounted, onUnmounted } from 'vue';

const counterRef = ref(null);
const years = ref(0);
const load = ref(0);
const customers = ref(0);

let observer = null;

const animateValue = (refValue, start, end, duration) => {
  let startTimestamp = null;
  const step = (timestamp) => {
    if (!startTimestamp) startTimestamp = timestamp;
    const progress = Math.min((timestamp - startTimestamp) / duration, 1);
    refValue.value = Math.floor(progress * (end - start) + start);
    if (progress < 1) {
      window.requestAnimationFrame(step);
    }
  };
  window.requestAnimationFrame(step);
};

onMounted(() => {
  observer = new IntersectionObserver(
    (entries) => {
      if (entries[0].isIntersecting) {
        animateValue(years, 0, 23, 2000);
        animateValue(load, 0, 30000, 2500);
        animateValue(customers, 0, 50, 2000);
        observer.disconnect(); // Animate only once
      }
    },
    { threshold: 0.5 } // Trigger when 50% of the element is visible
  );

  if (counterRef.value) {
    observer.observe(counterRef.value);
  }
});

onUnmounted(() => {
  if (observer) {
    observer.disconnect();
  }
});
</script>

<template>
  <section class="counter-section" ref="counterRef">
    <div class="counter-overlay"></div>
    <div class="counter-container">
      <div class="counter-item">
        <h3 class="counter-number">{{ years }}</h3>
        <p class="counter-label">{{ $t('home-page.counter.years-of-experience') }}</p>
      </div>
      <div class="counter-item">
        <h3 class="counter-number">+{{ load.toLocaleString() }}</h3>
        <p class="counter-label">{{ $t('home-page.counter.load-per-year') }}</p>
      </div>
      <div class="counter-item">
        <h3 class="counter-number">+{{ customers }}</h3>
        <p class="counter-label">{{ $t('home-page.counter.number-Of-Customers') }}</p>
      </div>
    </div>
  </section>
</template>

<style scoped>
.counter-section {
  background: url('@/assets/rectangle-8@2x.webp') no-repeat center center;
  background-size: cover;
  padding: 5rem 5%;
  position: relative;
  color: white;
}
.counter-overlay {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background-color: rgba(10, 45, 97, 0.8); /* Primary Blue Overlay */
}
.counter-container {
  position: relative;
  display: flex;
  justify-content: space-around;
  align-items: center;
  max-width: 1000px;
  margin: 0 auto;
  text-align: center;
}
.counter-number {
  font-size: 3.5rem;
  font-weight: 700;
  margin: 0 0 0.5rem 0;
}
.counter-label {
  font-size: 1.1rem;
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin: 0;
}
@media (max-width: 768px) {
  .counter-container { flex-direction: column; gap: 3rem; }
  .counter-number { font-size: 2.5rem; }
  .counter-label { font-size: 1rem; }
}
</style>